import validate from "/usr/src/app/node_modules/.pnpm/nuxt@3.16.2_@netlify+blobs@8.2.0_@parcel+watcher@2.5.1_@types+node@22.14.1_db0@0.3.2_eslint@9_b4non55rg7etplnd7xlqm3g2be/node_modules/nuxt/dist/pages/runtime/validate.js";
import _100_45external_45url_45handler_45global from "/usr/src/app/shared/common/middleware/100.external-url-handler.global.ts";
import _200_45impersonate_45global from "/usr/src/app/shared/common/middleware/200.impersonate.global.ts";
import _300_45auth_45global from "/usr/src/app/shared/common/middleware/300.auth.global.ts";
import redirect_45to_45agency_45global from "/usr/src/app/apps/frontend/www/middleware/redirect-to-agency.global.ts";
import manifest_45route_45rule from "/usr/src/app/node_modules/.pnpm/nuxt@3.16.2_@netlify+blobs@8.2.0_@parcel+watcher@2.5.1_@types+node@22.14.1_db0@0.3.2_eslint@9_b4non55rg7etplnd7xlqm3g2be/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  _100_45external_45url_45handler_45global,
  _200_45impersonate_45global,
  _300_45auth_45global,
  redirect_45to_45agency_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "sidebase-auth": () => import("/usr/src/app/node_modules/.pnpm/@sidebase+nuxt-auth@0.10.1_@netlify+blobs@8.2.0_magicast@0.3.5_next-auth@4.21.1_next@13.5.11__jchzg37gsbstvpfjua7exuwejy/node_modules/@sidebase/nuxt-auth/dist/runtime/middleware/sidebase-auth.js")
}